import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5623435c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "px-4 pt-5"
}
const _hoisted_2 = { class: "text-sm flex items-center" }
const _hoisted_3 = {
  key: 0,
  class: "relative min-h-300"
}
const _hoisted_4 = { class: "max-w-lg" }
const _hoisted_5 = { class: "m-w-4 m-h-4 mr-4 relative bg-white py-1.5" }
const _hoisted_6 = {
  key: 0,
  class: "mt-4"
}

import { h, ref, watch } from 'vue';
import {
	UiButton,
	UiCardDivider,
	UiConfirmation,
	UiCard,
	UiLoader,
	SvgIcon,
	useLoading
} from '@/ui-kit';
import PhoneNumberBusinessHours from '../components/PhoneNumberBusinessHours.vue';
import PhoneNumberPhoneMenu from '../components/PhoneNumberPhoneMenu.vue';
import PhoneNumberRingMembers from '../components/PhoneNumberRingMembers.vue';
import PhoneNumberVoicemail from '../components/PhoneNumberVoicemail.vue';
import PhoneNumberGeneral from '../components/PhoneNumberGeneral.vue';
import PhoneNumberTeamMembers from '../components/PhoneNumberTeamMembers.vue';
import PhoneNumberForwardCalls from '../components/PhoneNumberForwardCalls.vue';
import {
	useNewPhoneNumbers,
	usePhoneNumberDetails
} from '../composition';
import { useTimeZonesState } from '../state';
import { useToast } from 'vue-toastification';
import { useRouter } from 'vue-router';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'PhoneNumberDetails',
  setup(__props) {

const { loadTimeZones } = useTimeZonesState();
const {
	loadPhoneNumberDetailsData,
	forwardingActive,
	isLoading,
	selectedPhoneNumber
} = usePhoneNumberDetails();
const { removePhoneNumber } = useNewPhoneNumbers();
const { loading, toggleLoading } = useLoading(false);
const {
	loading: deleteLoading,
	toggleLoading: toggleDeleteLoading
} = useLoading();
const { success, warning } = useToast();
const router = useRouter();
const { isPaidAccount, userProfile } = useCompanyProfile();

const confirmationRef =
	ref<InstanceType<typeof UiConfirmation>>();

loadPhoneNumberDetailsData(selectedPhoneNumber.value!);

const sections = [
	{
		icon: 'incoming-call',
		component: () =>
			h(
				'span',
				{ class: 'text-blue-600' },
				'Incoming call'
			)
	},
	{
		icon: 'redirect',
		component: PhoneNumberForwardCalls
	},
	{
		icon: 'clock',
		component: PhoneNumberBusinessHours
	},
	{
		icon: 'dialpad',
		component: PhoneNumberPhoneMenu
	},
	{
		icon: 'call-members',
		component: PhoneNumberRingMembers
	},
	{
		icon: 'phone-missed',
		component: PhoneNumberVoicemail
	}
];

loadTimeZones();
const toast = useToast();

async function triggerDeletePhoneNumber() {
	const result = await confirmationRef.value?.openDialog(
		`Delete ${selectedPhoneNumber.value?.friendlyName}?`,
		'Are you sure you want delete this phone number. You won`t be able to use it for sending sms and making calls.'
	);
	if (!result) {
		return;
	}
	toggleDeleteLoading();
	await removePhoneNumber(selectedPhoneNumber.value!.id);
	success('Phone number was removed');
	router.replace({ name: 'PhoneNumbers' });
}

watch(selectedPhoneNumber, () => {
	if (
		!selectedPhoneNumber.value &&
		!deleteLoading.value
	) {
		warning('Phone number was removed.');
		return router.replace({ name: 'PhoneNumbers' });
	}
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_unref(selectedPhoneNumber))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_RouterLink, {
          tabindex: "0",
          to: { name: 'PhoneNumbers' }
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(UiButton), {
              class: "mb-2",
              theme: "transparent !h-8 !w-auto !min-w-auto !px-2 -mx-2"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_unref(SvgIcon), {
                    name: "arrow",
                    class: "h-3 w-3 mr-2 transform rotate-180"
                  }),
                  _createTextVNode("Back to phone numbers ")
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(UiCardDivider), {
          title: _unref(selectedPhoneNumber).phoneNumber,
          subtitle: "Settings related to this phone number"
        }, null, 8, ["title"]),
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_unref(UiLoader), {
                wrapperClass: "base text-reverse",
                loadingText: "Loading phone number details..."
              })
            ]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(PhoneNumberGeneral),
              _createVNode(PhoneNumberTeamMembers),
              _createVNode(_unref(UiCard), {
                theme: "white",
                class: "mt-8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UiCardDivider), { title: "Call workflow" }),
                  _createElementVNode("div", _hoisted_4, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(sections, (section, i) => {
                      return _createElementVNode("div", {
                        class: "pb-4 flex items-center relative",
                        key: i
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass([
								' w-px absolute left-3 section',
								{
									'bg-blue-600':
										i === 0 ||
										!_unref(forwardingActive),
									'bg-dark-blue-400 opacity-50':
										_unref(forwardingActive) &&
										i !== 0,
									'section--first':
										i === 0,
									'section--second':
										i === 1,
									'section--last':
										i ===
										sections.length - 1
								}
							])
                        }, null, 2),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_unref(SvgIcon), {
                            name: section.icon,
                            class: _normalizeClass({
									'text-blue-600':
										i <= 1 ||
										(!_unref(forwardingActive) &&
											i > 1),
									'text-dark-blue-400 opacity-50':
										_unref(forwardingActive) &&
										i > 1
								})
                          }, null, 8, ["name", "class"])
                        ]),
                        (section.component)
                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(section.component), {
                              key: 0,
                              isForwardingActive: 
								!!_unref(forwardingActive)
							,
                              disabled: _unref(loading),
                              onLoading: _unref(toggleLoading)
                            }, null, 40, ["isForwardingActive", "disabled", "onLoading"]))
                          : _createCommentVNode("", true)
                      ])
                    }), 64))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_unref(UiCard), {
                theme: "white",
                class: "mt-8"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(UiCardDivider), {
                    title: "Danger zone",
                    subtitle: "By removing this phone number you won't be able to use it to send sms and make calls."
                  }),
                  _createVNode(_unref(UiButton), {
                    onClick: triggerDeletePhoneNumber,
                    theme: "danger-outlined",
                    disabled: 
						!_unref(userProfile)?.canRemovePhoneNumbers ||
						!_unref(selectedPhoneNumber).canBeRemoved
					
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Delete Phone number ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  (
						!_unref(userProfile)?.canRemovePhoneNumbers ||
						!_unref(selectedPhoneNumber).canBeRemoved
					)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, " To prevent fraud we are deleting phone numbers only by requests "))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ], 64)),
        _createVNode(_unref(UiConfirmation), {
          ref_key: "confirmationRef",
          ref: confirmationRef,
          loading: _unref(deleteLoading)
        }, null, 8, ["loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})